module.exports = __webpack_public_path__ + "img/57-image-1@2x.80db3e42.png";